module.exports = __webpack_public_path__ + "static/media/Marvel-Comics-Logo.575beca3.png";